import { useQuery } from '@tanstack/react-query'
import { ApiError, useApiFetch } from '../../shared/api'
import type { HuntReplayDto } from './huntReplayDto'

export const HUNT_REPLAY_QUERY_KEY = 'campfire'

export function useHuntReplay(huntId: string | undefined) {
  const apiFetch = useApiFetch()

  return useQuery<HuntReplayDto, ApiError>({
    queryKey: [HUNT_REPLAY_QUERY_KEY, 'hunt-replay', huntId],
    enabled: huntId !== undefined && huntId !== '',
    queryFn: () => apiFetch<HuntReplayDto>(`/hunts/${encodeURIComponent(huntId!)}/replay`),
    // An ended hunt's archive never changes, so a refetch can only re-download
    // several megabytes to produce the same answer.
    staleTime: Infinity,
    gcTime: 30 * 60_000,
    refetchOnWindowFocus: false,
    // 404 means the hunt has no archive and 502 means the archive service is
    // unreachable; neither is fixed by hammering it. Anything else gets one retry.
    retry: (failureCount, error) =>
      error.status !== 404 && error.status !== 502 && failureCount < 1,
  })
}
